import { Button } from "common/src/styles";
import shareOnFarcaster from "../../assets/farcaster-logo.svg";
import XTwitter from "../../assets/x-logo.svg";
import Link from "../../assets/link.svg";
import xIcon from "../../assets/x-logo-black.png";
import { useNavigate } from "react-router-dom";
import { useAccount } from "wagmi";
import { useState } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShareButtons = _ref => {
  let {
    attestationLink,
    isTop
  } = _ref;
  const twitterShareUrl = createTwitterAttestationShareUrl(attestationLink);
  const farcasterShareText = getFarcasterAttestationShareText();
  const farcasterShareUrl = createFarcasterShareUrl(farcasterShareText, [attestationLink]);
  const [tooltipVisible, setTooltipVisible] = useState(false); // Add state for tooltip visibility

  const handleCopy = () => {
    navigator.clipboard.writeText(attestationLink);
    setTooltipVisible(true); // Show tooltip
    setTimeout(() => setTooltipVisible(false), 1000); // Hide tooltip after 1 second
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center z-30",
    children: [/*#__PURE__*/_jsx("span", {
      className: "font-modern-era-medium  pb-2 text-[24px]/[28px]",
      children: "Share with your network!"
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex items-center gap-2 pb-1",
      children: [/*#__PURE__*/_jsx("div", {
        className: "rainbow-border-icon",
        children: /*#__PURE__*/_jsx("div", {
          className: "icon-button ",
          children: /*#__PURE__*/_jsx("img", {
            className: "icon",
            alt: "Frame",
            src: shareOnFarcaster,
            onClick: () => window.open(farcasterShareUrl, "_blank")
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "rainbow-border-icon",
        children: /*#__PURE__*/_jsx("div", {
          className: "icon-button ",
          children: /*#__PURE__*/_jsx("img", {
            className: "icon",
            alt: "Frame",
            src: XTwitter,
            onClick: () => window.open(twitterShareUrl, "_blank")
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "rainbow-border-icon",
        children: [/*#__PURE__*/_jsx("div", {
          className: "icon-button ",
          children: /*#__PURE__*/_jsx("img", {
            className: "icon",
            alt: "Frame",
            src: Link,
            onClick: handleCopy // Update onClick to use handleCopy
          })
        }), tooltipVisible &&
        /*#__PURE__*/
        // Render tooltip conditionally
        _jsx("span", {
          className: `${isTop ? "copytooltip-top" : "copytooltip-bottom"}`,
          children: "Copied!"
        })]
      })]
    })]
  });
};
export function createTwitterShareText(props) {
  var _props$roundName$trim, _props$roundName;
  return `I just donated to ${(_props$roundName$trim = (_props$roundName = props.roundName) === null || _props$roundName === void 0 ? void 0 : _props$roundName.trim()) !== null && _props$roundName$trim !== void 0 ? _props$roundName$trim : "a round"}${props.isMrc && props.roundName ? " and more" : ""} on @gitcoin's @grantsstack. Join me in making a difference by donating today, and check out the projects I supported on my Donation History page!\n\nhttps://explorer.gitcoin.co/#/contributors/${props.address}`;
}
export function createTwitterShareUrl(props) {
  const shareText = createTwitterShareText(props);
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
}
export function createTwitterAttestationShareText(attestationLink) {
  return `Just minted my donation on @gitcoin 🫡\n\nMy impact is now onchain!\n\n${attestationLink}`;
}
export function createTwitterAttestationShareUrl(attestationLink) {
  const shareText = createTwitterAttestationShareText(attestationLink);
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
}
export function getFarcasterAttestationShareText() {
  const encodedText1 = encodeURIComponent(`Just minted my donation on  `);
  const encodedText2 = encodeURIComponent(` 🫡\n\nMy impact is now onchain!`);

  // NB: mentions should not be encoded
  return `${encodedText1}@gitcoin${encodedText2}`;
}
export function createFarcasterShareUrl(shareText, embedLinks) {
  // NB: embed links should not be encoded
  return `https://warpcast.com/~/compose?text=${shareText}${embedLinks.map(link => `&embeds[]=${link}`)}`;
}
export function TwitterButton(props) {
  const shareUrl = createTwitterShareUrl(props);
  return /*#__PURE__*/_jsxs(Button, {
    type: "button",
    onClick: () => window.open(shareUrl, "_blank"),
    className: "flex items-center justify-center shadow-md font-mono text-xs rounded-lg border-1 text-black bg-white px-4 sm:px-10 hover:shadow-lg",
    "data-testid": "x-button",
    children: [/*#__PURE__*/_jsx("img", {
      src: xIcon,
      alt: "X logo",
      className: "w-4 h-4 font-semibold"
    }), /*#__PURE__*/_jsx("span", {
      className: "ml-2",
      children: "Share on X"
    })]
  });
}
export const ThankYouSectionButtons = _ref2 => {
  let {
    roundName,
    isMrc
  } = _ref2;
  const {
    address
  } = useAccount();
  const navigate = useNavigate();
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center xl-mt-[10%] lg-mt-[10%] md-mt-[10%]",
    children: [/*#__PURE__*/_jsx("p", {
      className: "text-5xl font-modern-era-medium",
      children: "Thank you for"
    }), /*#__PURE__*/_jsx("h1", {
      className: "text-5xl font-modern-era-medium mb-8 ",
      children: "your support!"
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-5 items-center justify-center",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "flex gap-5 items-center justify-center",
        children: [/*#__PURE__*/_jsx(TwitterButton, {
          address: address !== null && address !== void 0 ? address : "0x",
          roundName: roundName,
          isMrc: isMrc
        }), /*#__PURE__*/_jsx(Button, {
          type: "button",
          onClick: () => navigate(`/contributors/${address}`),
          className: "items-center justify-center text-xs text-black rounded-lg border border-solid bg-grey-100 border-grey-100 px-2 hover:shadow-md sm:px-10 font-mono",
          "data-testid": "donation-history-button",
          children: "Donation History"
        })]
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        $variant: "outline",
        onClick: () => navigate("/"),
        className: "items-center justify-center text-xs rounded-lg w-[193px] border-1 bg-orange-100 hover:shadow-md px-10 font-mono",
        "data-testid": "home-button",
        children: "Back home"
      })]
    }), " "]
  });
};